import { createContext } from 'react';

export type CancelUpcomingTransactionCtx = {
  showCancelUpcomingTransactionErrorAlert: boolean;
  sendCancelUpcomingTransactionError: string;
};

const CancelUpcomingTransactionDialogueContext = createContext<CancelUpcomingTransactionCtx>({
  showCancelUpcomingTransactionErrorAlert: false,
  sendCancelUpcomingTransactionError: '',
});

export default CancelUpcomingTransactionDialogueContext;